import { httpClient } from '../api/http.client';
import {
  Subcategory,
  SubcategoriesResponse,
  CreateSubcategoryDto,
  UpdateSubcategoryDto,
} from '@/domain/entities';

export class SubcategoryRepository {
  async getByCategoryId(categoryId: number): Promise<SubcategoriesResponse> {
    return httpClient.get<SubcategoriesResponse>(
      `/api/admin/subcategories?categoryId=${categoryId}`
    );
  }

  async getById(id: number): Promise<Subcategory> {
    return httpClient.get<Subcategory>(`/api/admin/subcategories/${id}`);
  }

  async create(subcategory: CreateSubcategoryDto): Promise<{ message: string }> {
    return httpClient.post<{ message: string }>('/api/admin/subcategories', subcategory);
  }

  async update(id: number, updates: UpdateSubcategoryDto): Promise<{ message: string }> {
    return httpClient.put<{ message: string }>(`/api/admin/subcategories/${id}`, updates);
  }

  async delete(id: number): Promise<void> {
    return httpClient.delete<void>(`/api/admin/subcategories/${id}`);
  }
}

export const subcategoryRepository = new SubcategoryRepository();

